import { State } from '../types/State';

export const selectIsLegacyBrowser = (state: Pick<State, 'isLegacyBrowser'>) =>
  state.isLegacyBrowser;
